import tasksTemplate from './tasks.html';
import taskAddTemplate from './taskAdd.html';
import taskDetailTemplate from './taskDetail.html';

/* @ngInject */
const TasksConfig = ($stateProvider) => {
    $stateProvider
        .state('tasks', {
            url: '/tasks',
            template: tasksTemplate,
            controller: 'TasksController',
            controllerAs: 'tasks',
            params: {defaultTab: 'TASKS'}
        })
        .state('taskAdd', {
            url: '/tasks/add',
            template: taskAddTemplate,
            controller: 'TaskAddController',
            controllerAs: 'taskAdd',
            params: {campaignId: null, contactId: null, investorId: null, customerInvestorId: null, isCustomerContact: false, tasksCount: null}
        })
        .state('taskEdit', {
            url: '/tasks/edit/:taskId',
            template: taskAddTemplate,
            controller: 'TaskAddController',
            controllerAs: 'taskAdd',
            params: { callingPage: null, referenceId: null, tasksCount: null }
        })
        .state('taskDetail', {
            url: '/tasks/:taskId',
            template: taskDetailTemplate,
            controller: 'TaskDetailController',
            controllerAs: 'taskDetail',
            params: { callingPage: null, referenceId: null, tasksCount: null }
        });
};

export default TasksConfig;



/** WEBPACK FOOTER **
 ** ./src/app/components/tasks/tasks.config.js
 **/